import { ADDPRODUCT, MINUSPRODUCT, PLUSPRODUCT, DELETEPRODUCT } from "./actionTypes";

export const addproduct = (product)=>{
    return {
        type: ADDPRODUCT,
        payload: product,
    }
}
export const minusproduct = (id)=>{
    return {
        type: MINUSPRODUCT,
        payload: id,
    }
}
export const plusproduct = (id)=>{
    return {
        type: PLUSPRODUCT,
        payload: id,
    }
}
export const deleteproduct = (id)=>{
    return {
        type: DELETEPRODUCT,
        payload: id,
    }
}